import {
  ACTION_LOAD_CUSTOM_BANNERS__REQUEST,
  ACTION_LOAD_CUSTOM_BANNERS__SUCCESS,
  ACTION_LOAD_CUSTOM_BANNERS__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_CUSTOM_BANNERS__REQUEST:
    case ACTION_LOAD_CUSTOM_BANNERS__SUCCESS:
      return null;

    case ACTION_LOAD_CUSTOM_BANNERS__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
